/* Etiquette — Mobile Sticky Add to Cart
   Renders a fixed bottom button on mobile; appears once the real ATC
   is scrolled out of view; clicking it triggers the real ATC (GoKwik-safe). */
(function () {
  function init() {
    if (window.matchMedia('(max-width: 749px)').matches === false) return;

    var realBtn = document.querySelector('.product-form__submit')
      || document.querySelector('button[name="add"]');
    if (!realBtn) return;
    if (document.querySelector('.etq-sticky-atc')) return; // already built

    // Build the bar
    var bar = document.createElement('div');
    bar.className = 'etq-sticky-atc';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'etq-sticky-atc__button';
    btn.textContent = 'Add to Cart';
    bar.appendChild(btn);
    document.body.appendChild(bar);

    // Mirror the real button's disabled / sold-out state + label
    function syncState() {
      var soldOut = realBtn.disabled;
      btn.disabled = soldOut;
      var realText = realBtn.querySelector('span') ? realBtn.querySelector('span').textContent.trim() : realBtn.textContent.trim();
      if (realText) btn.textContent = realText;
    }
    syncState();
    // re-sync when variant changes flip availability
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') setTimeout(syncState, 80);
    }, true);

    // Click sticky -> click real button (keeps variant + GoKwik logic intact)
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      realBtn.click();
    });

    // Show the bar only after the real button scrolls out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // visible when real button is NOT on screen
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(realBtn);
    } else {
      // Fallback: simple scroll check
      window.addEventListener('scroll', function () {
        var r = realBtn.getBoundingClientRect();
        var offscreen = r.bottom < 0 || r.top > window.innerHeight;
        bar.classList.toggle('is-visible', offscreen);
      }, { passive: true });
    }
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();